module.exports = __webpack_public_path__ + "static/3-cc536fe93bfa96d52f8312826fe7adbf.mp4";